export enum EnumCorpSize {
    small,
    default,
    large,
    extraLarge,
}

export enum EnumCorpTypePb {
    default,
    indeterminate
}